import QueryText from '../../atoms/text/queryText';
import useList from '../../../../shared/components/utils/hooks/useList';
import { AutoComplete } from '@shared/types/interfaces/search';
import { selectMagicRemoteEnabled } from '../../../../shared/store/slices/magicRemote.slice';
import { useAppSelector } from '../../../../shared/store/hooks';
import { useState } from 'react';

function Query({
  index,
  query,
  action,
}: {
  index: number;
  query: AutoComplete;
  action: (query: AutoComplete) => void;
}) {
  const enabled = useAppSelector(selectMagicRemoteEnabled);
  const { listIndex, focused: queryFocused } = useList(index);
  const [hovered, setHovered] = useState(false);
  const focused = !enabled && queryFocused && index === listIndex;

  return (
    <QueryText
      focused={hovered || focused}
      onClick={() => action(query)}
      onPointerEnter={() => setHovered(true)}
      onPointerLeave={() => setHovered(focused)}
    >
      {query.title}
    </QueryText>
  );
}

export default Query;
